<template>
  <div class="header-city">
    <div class="header-country-selector"
         v-if="loading"
         @click="showMobileBord"
    >
      <div class="header-country-selector-title">
        <div class="flag">
          <img
              :src="`/images/flag-country/${currencyDto['russianPostCountryId']}.png`"
              :alt="currencyDto['russianName']"
          >
        </div>
        <div class="header-country-selector-name">
          <p>{{ currencyDto['russianName'] }}</p>
        </div>
      </div>
      <div class="header-country-selector-list" @click.stop :class="[{'mobile-bord': mobileBord}]">
        <div class="header-country-selector-list__wrap">
          <div class="header-country-selector-list__wrap--countries">
            <span>Доставка в</span>
            <div class="countries-list">
              <div class="countries-active"
                   :class="{'selected': showCountry}"
                   @click="changeShowCountry">
                <span>{{ currencyDto['russianName'] }}</span>
                <span class="dropdown-icon" :class="{'arrow': showCountry}"/>
              </div>
              <transition name="tab">
                <div class="countries-all" ref="parentCou" v-show="showCountry">
                  <div class="search-country">
                    <input type="text" name="country"
                           class="form-control search"
                           ref="filterSelect"
                           v-model="countrySearch"
                           @input="targetChangeCountry">
                    <span class="dropdown-icon"></span>
                  </div>
                  <div class="countries"
                       ref="childCou">
                    <div class="country"
                         v-for="item in filteredListCountry"
                         @click="selectedCountry(item)">
                      <div class="flag">
                        <img :src="`/images/flag-country/${item['id']}.png`" :alt="item['name']"/>
                      </div>
                      <div class="header-country-selector-name">
                        <p>{{ item['name'] }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="header-country-selector-list__wrap--countries">
            <span>Валюта</span>
            <div class="countries-list">
              <div class="countries-active"
                   :class="{'selected': showCurrency}"
                   @click="changeShowCurrency">
                <span>{{ currencyDto['currencyCode'] }}</span>
                <span class="dropdown-icon" :class="{'arrow': showCurrency}"/>
              </div>
              <transition name="tab">
                <div class="currency-all" v-show="showCurrency">
                  <div class="currency">
                    <div class="currency-name"
                         v-for="item in filteredListCurrency"
                         @click="selectedCurrency(item)">
                      <p>{{ item['char_code'] }}</p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storeModal from "@/modals/store"
import {mapState} from "vuex"

export default {
  data() {
    return {
      countrySearch: '',
      mobileBord: false,
      showCountry: false,
      showCurrency: false,
    }
  },
  methods: {
    changeShowCountry() {
      if (this.showCurrency) {
        this.showCurrency = !this.showCurrency
      }
      this.showCountry = !this.showCountry
    },
    changeShowCurrency() {
      if (this.showCountry) {
        this.showCountry = !this.showCountry
      }
      this.showCurrency = !this.showCurrency
    },
    showMobileBord() {
      this.mobileBord = !this.mobileBord
    },
    targetChangeCountry() {
        let clientHeight = this.$refs['childCou']['clientHeight']
        let scrollHeight = this.$refs['childCou']['scrollHeight']
        if (clientHeight >= scrollHeight) {
          this.$refs['parentCou']['style']['height'] = "auto"
        }
        if (scrollHeight > 300) {
          this.$refs['parentCou']['style']['height'] = "300px"
        }
    },
    selectedCountry(item) {
      let domain = item['domain'].trim(),
        id = item['id']
      window.location.href = `/auth/redirect-domain?domain=${domain}&idCountry=${id}`
    },
    selectedCurrency(item) {
      let currencyCode = item['char_code'].trim()
      window.location.href = `/auth/set-currency?charCode=${currencyCode}`
    },
    /** закрываем поиск при клике в не элемента */
    onClickOutsideCountry(e) {
      this.showCountry = this.$el.contains(e.target) && this.showCountry;
      this.showCurrency = this.$el.contains(e.target) && this.showCurrency;
    }
  },
  computed: {
    /** фильтруем список при вводе текста */
    filteredListCountry() {
      let comp = this.countrySearch;
      return Object.values(this.listCountriesDomain).filter(elem => {
        if(comp === '') {
          return true
        } else {
          if (this.currencyDto['russianPostCountryId'] != elem['id']) {
            return elem['name'].toLowerCase().indexOf(comp.toLowerCase()) > -1
          }
        }
      })
    },
    filteredListCurrency() {
      return this.listCurrency.filter(elem => elem['char_code'] != this.currencyDto['currencyCode'])
    },
    ...mapState({
      isGuest: state => state.countryUser.countriesData.isGuest,
      currencyDto: state => state.countryUser.countriesData.currencyDto,
      listCountriesDomain: state => state.countryUser.countriesData.listCountriesDomain,
      listCurrency: state => state.countryUser.countriesData.listCurrency,
      loading: state => state.countryUser.countriesData.loading,
    })
  },
  created() {
    storeModal.dispatch('countryUser/defineCountryUser')
    document.addEventListener('click', this.onClickOutsideCountry);
  },
  updated() {
    /** фокус на select поиска страны */
    this.$nextTick(() => {
      if (this.showCountry) {
        this.$refs.filterSelect.focus();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutsideCountry)
  },
}
</script>
